<template>
	<div v-if="order">
		<bread-crumbs
			:bread-crumbs="breadCrumbs"
			:current-title="$gettext('Add Invoice')"
			class="breadcrumbstyle"
		/>
		<create-invoice-card
			:order-id="order.id"
		/>
	</div>
</template>

<script>
import {
	axios,
} from '../../../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'InvoiceAdd',

	data () {
		return {
			orderId: '',
			order: null
		};
	},

	computed: {
		breadCrumbs () {
			return this.order ? {
				['/bo/orders/view?id=' + this.order.id]: (this.$gettext('Order') + (' #' + this.order.orderkey))
			} : {
			};
		}
	},

	mounted () {
		this.orderId = new URLSearchParams(window.location.search.substring(1)).get('order_id');
		this.getOrder();
	},

	methods: {
		/**
		 *
		 */
		getOrder () {
			axios.get(`/api/v0/orders/${this.orderId}`).then(({
				data: order,
			}) => {
				this.order = order;
			}).catch((error) => {
				displayError(this.$gettext('Something has gone wrong during data retrieval'));
				window.captureException(error);
			});
		}
	}
};
</script>
